export const siteLanguagesEng = 'en';
export const siteLanguagesFr = 'fr';
export const globalErrorMsgEng = 'Please correct the errors below.';
export const globalErrorMsgFr = 'Merci de corriger les erreurs ci-dessous';
export const delTimeValue = [
  { id: 1, name: 'Closed' },
  { id: 2, name: '24 hours' },
  { id: 3, name: '4:00 am' },
  { id: 4, name: '4:30 am' },
  { id: 5, name: '5:00 am' },
  { id: 6, name: '5:30 am' },
  { id: 7, name: '6:00 am' },
  { id: 8, name: '6:30 am' },
  { id: 9, name: '7:00 am' },
  { id: 10, name: '7:30 am' },
  { id: 11, name: '8:00 am' },
  { id: 12, name: '8:30 am' },
  { id: 13, name: '9:00 am' },
  { id: 14, name: '9:30 am' },
  { id: 15, name: '10:00 am' },
  { id: 16, name: '10:30 am' },
  { id: 17, name: '11:00 am' },
  { id: 18, name: '11:30 am' },
  { id: 19, name: '12:00 pm' },
  { id: 20, name: '12:30 pm' },
  { id: 21, name: '1:00 pm' },
  { id: 22, name: '1:30 pm' },
  { id: 23, name: '2:00 pm' },
  { id: 24, name: '2:30 pm' },
  { id: 25, name: '3:00 pm' },
  { id: 26, name: '3:30 pm' },
  { id: 27, name: '4:00 pm' },
  { id: 28, name: '4:30 pm' },
  { id: 29, name: '5:00 pm' },
  { id: 30, name: '5:30 pm' },
  { id: 31, name: '6:00 pm' },
  { id: 32, name: '6:30 pm' },
  { id: 33, name: '7:00 pm' },
  { id: 34, name: '7:30 pm' },
  { id: 35, name: '8:00 pm' },
  { id: 36, name: '8:30 pm' }
];